import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'

const CompetitionManage = () => import('../views/competition/CompetitionManage.vue')
const CompetitionDetail = () => import('../views/competition/CompetitionDetail.vue')
const RegistrationOrder = () => import('../views/order/RegistrationOrder.vue')
const Login = () => import('../views/login/index.vue')
const Placeholder = { template: '<div style="padding:16px">即将上线</div>' }

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录', requiresAuth: false }
  },
  {
    path: '/',
    redirect: '/competition/manage'
  },
  {
    path: '/competition/manage',
    name: 'CompetitionManage',
    component: CompetitionManage,
    meta: { title: '赛事管理', affix: true }
  },
  {
    path: '/competition/:id',
    name: 'CompetitionDetail',
    component: CompetitionDetail,
    meta: { title: '赛事详情' }
  },
  {
    path: '/competition/scoreborad',
    name: 'Scoreborad',
    component: () => import('../views/competition/CompetitionScoreboard.vue'),
    meta: { title: '大屏展示' }
  },
  { path: '/order/registration', name: 'RegistrationOrder', component: RegistrationOrder, meta: { title: '报名订单' } },
  { path: '/system/role', name: 'Role', component: () => import('../views/system/RolePermission.vue'), meta: { title: '角色权限' } },
  { path: '/system/account', name: 'AccountManage', component: () => import('../views/system/AccountManage.vue'), meta: { title: '账号管理' } },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const requiresAuth = to.meta.requiresAuth !== false

  console.log('路由守卫检查:', { to: to.path, token: !!token, requiresAuth })

  // 如果访问登录页且已登录，重定向到首页
  if (to.name === 'Login' && token) {
    console.log('已登录，重定向到首页')
    next('/')
    return
  }

  // 如果需要认证且未登录，重定向到登录页
  // if (requiresAuth && !token) {
  //   console.log('需要认证但未登录，重定向到登录页')
  //   next('/login')
  //   return
  // }

  console.log('路由守卫通过，继续导航')
  next()
})

export default router


